<div class="container-fluid content-bg">
        <div class="card card-register mx-auto mt-5">
            <div class="card-header">Register an Account
                <button type="button" class="close" data-dismiss="modal" (click)="registerClose()">&times;</button>
            </div>
            <div class="card-body">
                <p style="color: red;"> ** Please Fill All the fields to enable Send Button **</p>
                <form role="form" name="registerUser">
                    <div class="form-group">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="first">First Name</label>
                                <input type="first" pattern="[a-zA-Z ]*" class="form-control" id="first" name="first"
                                    ngModel #firstref="ngModel" [(ngModel)]="first_name" required autofocus>
                                <div *ngIf="firstref.errors &&(firstref.touched || firstref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!firstref.errors?.pattern">
                                        Please use Alphabets only
                                    </div>
                                    <div [hidden]="!firstref.errors?.required">
                                        First Name Required
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="last">Last Name</label>
                                <input type="first" pattern="[a-zA-Z ]*" class="form-control" id="last" name="last" ngModel
                                    #lastref="ngModel" [(ngModel)]="last_name" required autofocus>
                                <div *ngIf="lastref.errors &&(lastref.touched || lastref.dirty)" class="alert alert-danger">
                                    <div [hidden]="!lastref.errors?.pattern">
                                        Please use Alphabets only
                                    </div>
                                    <div [hidden]="!lastref.errors?.required">
                                        Last Name Required
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="form-row">
                            <div class="col-md-6">
                                <label for="email">Email</label>
                                <input type="email" pattern="[^@]+@[^@]+\.[a-zA-Z]{2,6}" class="form-control" id="email"
                                    name="email" ngModel #emailref="ngModel" [(ngModel)]="email" required autofocus>
                                <div *ngIf="emailref.errors &&(emailref.touched || emailref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!emailref.errors?.pattern">
                                        Invalid pattern
                                    </div>
                                    <div [hidden]="!emailref.errors?.required">
                                        Email Required
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <label for="mobile">Country Code</label>
                                <select class="form-control" [(ngModel)]="country" name="country" ngModel #cref="ngModel" required>
                                    <option [ngValue]="undefined"hidden>Code</option>
                                    <option *ngFor="let suit of codeDropdown">{{suit}}</option>
                                </select>
                                <div *ngIf="cref.errors &&(cref.touched || cref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!cref.errors?.required">
                                        Country Code Required
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="mobile">Mobile</label>
                                <input type="number" pattern="^((\\+91-?)|0)?[0-9]{10}$" minlength="10" maxlength="12"
                                    class="form-control" id="mobile" name="mobile" ngModel #mobileref="ngModel"
                                    [(ngModel)]="mobile" required autofocus [readonly]="otp">
                                <div *ngIf="mobileref.errors &&(mobileref.touched || mobileref.dirty)"
                                    class="alert alert-danger">
                                    <div [hidden]="!mobileref.errors?.pattern">
                                        Invalid Pattern
                                    </div>
    
                                    <div [hidden]="!mobileref.errors?.minlength">
                                        Number must be atleast 10 numbers
                                    </div>
                                    <div [hidden]="!mobileref.errors?.required">
                                        Mobile Required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="form-group" *ngIf="!success">
                        <div class="form-row">
                            <div class="styles-buttons">
                                <div class="col-md" *ngIf="!otp">
                                    <input type="send" name="send" id="send" class="btn btn-primary btn-block" tabIndex="9"
                                        value="Send" (click)="send()" readonly>
                                    <!-- [disabled]="otp"
                                    [disabled]="!first_name || !last_name || !email || !mobile || !country" readonly -->
    
                                </div>
                                <div class="col-md" *ngIf="otp && !enable_btn">
                                    <input type="verify" name="verify" id="verify" class="btn btn-primary btn-block"
                                        tabIndex="9" value="Verify" (click)="verify()" readonly>
                                    <!-- [disabled]="!otp" -->
                                </div>
                                <div class="col-md" *ngIf="enable_btn">
                                    <input type="resend" name="resend" id="resend"
                                        class="btn btn-primary btn-block otp-focus" tabIndex="9" value="Resend"
                                        (click)="resend()" readonly>
                                    <!-- [disabled]="!enable_btn" -->
                                    <!-- || otp_resend -->
                                </div>
                            </div>
                                <div class="col-md-4 otp-line-styles" *ngIf="otp">
                                    <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent" [config]="config"></ng-otp-input>
                                </div>
                            
                                <div class="col-md-2 timer-styles" *ngIf="otp">
                                    <div>
                                        <countdown [config]="t"></countdown>
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div class="form-group" *ngIf="success">
                        <div class="form-row">
                            <div class="col-md-6">
                                <label>Password <sup class="error">*</sup></label>
                                <show-hide-password size="md" btnStyle="primary" [btnOutline]="false">
                                    <input type="password" name="password" minlength="8" data-toggle="tooltip" id="password"
                                        class="form-control input-md floatlabel" placeholder="Enter Password" autofocus="on"
                                        autocomplete="off" maxlength="60" tabIndex="5" [(ngModel)]="password" ngModel
                                        #pwdref="ngModel" required />
                                </show-hide-password>
                               
                                <span id="password_error" class="error"></span>
                                <div *ngIf="pwdref.errors &&(pwdref.touched || pwdref.dirty)" class="alert alert-danger">
                                    <div [hidden]="!pwdref.errors?.minlength">
                                        Min 8 chars required
                                    </div>
                                    <div [hidden]="!pwdref.errors?.required">
                                        Password Required
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label>Confirm Password <sup class="error">*</sup></label>
                                <show-hide-password size="md" btnStyle="primary" [btnOutline]="false">
                                    <input type="password" name="cpassword" id="cpassword"
                                        class="form-control input-md floatlabel" minlength="8"
                                        placeholder="Enter Confirm Password" autofocus="on" autocomplete="off"
                                        maxlength="60" tabIndex="6" [(ngModel)]="cnfmpassword" ngModel #cpwdref="ngModel"
                                        required />
                                </show-hide-password>
                                <span id="cpassword_error" class="error"></span>
                                <div *ngIf="cpwdref.errors &&(cpwdref.touched || cpwdref.dirty)" class="alert alert-danger">
                                    <div [hidden]="!cpwdref.errors?.minlength">
                                        Min 8 chars required
                                    </div>
                                    <div [hidden]="!cpwdref.errors?.required">
                                        Confirm Password Required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="success">
                        <input type="submit" name="submit" id="submit" class="btn btn-primary btn-block" tabIndex="9"
                            value="Register" (click)="reg()">
                    </div>
                    <!--<a class="btn btn-primary btn-block" href="login.html">Register</a>-->
                </form>
                <hr>
                <div class="text-center">
                    <a class="d-block small mt-3" href="login">Login Page</a>
                    <a class="d-block small" href="home">Back To Home</a>
                </div>
            </div>
        </div>
    
        <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
            <p style="color: white">Loading </p>
        </ngx-spinner>
    </div>